import { FC } from 'react';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
} from 'recharts';
import dayjs from 'dayjs';
import { ITonnageSeriesMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITonnageSeriesMetric | null;
  period?: string;
  height?: number;
}

export const TonnageSeriesChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.weeks || data.weeks.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <BarChart data={data.weeks} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="week" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(_value, _name, props) => {
            const { week, tonnage } = props.payload;
            return [`${tonnage} kg`, dayjs(week).format('DD/MM/YYYY')];
          }}
        />
        <Bar dataKey="tonnage" fill="var(--c-text-0)" radius={[4, 4, 0, 0]} />
        {data.injuryMarkers?.map((marker) => (
          <ReferenceLine key={marker.injuryId} x={marker.date} stroke="var(--ri-critical)" strokeWidth={1.5} />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
